import { addStyles } from 'ethcss'
import { color, IStyles } from 'theme'

export const checkboxStyles: IStyles = {
    root: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: 8,
        cursor: 'pointer',
        userSelect: 'none',
    },
    disabled: {
        opacity: 0.55,
        cursor: 'default',
    },
    input: {
        position: 'absolute',
        opacity: 0,
        width: 0,
        height: 0,
        margin: 0,
        pointerEvents: 'none',
    },
    box: {
        boxSizing: 'border-box',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0,
        width: 16,
        height: 16,
        minWidth: 16,
        minHeight: 16,
        lineHeight: 0,
        overflow: 'hidden',
        borderRadius: 4,
        backgroundColor: color.bgWhiteSecondary,
        border: `1px solid ${color.borderDarkSecondary}`,
        transition: 'background-color 150ms ease, border-color 150ms ease',
    },
    boxChecked: {
        backgroundColor: color.bgDarkPrimary,
        borderColor: color.bgDarkPrimary,
    },
    icon: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 0,
        width: 10,
        height: 8,
    },
    label: {
        fontSize: 14,
        lineHeight: '16px',
        color: color.fontDarkHigh,
    },
}

addStyles(checkboxStyles)
